import tr from "@/utils/Tr";

export const inspirationsVideosGuides = () => [
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Quick-Guide-Inspirations.png",
        imageAlt: "Inspirations",
        imageLink: "https://youtu.be/aWWu3GOvmfk",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/03/Fashion.png",
        imageAlt: "Generating Fashion Inspirations",
        imageLink: "https://youtu.be/_2HbQ86jpGY",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/03/Home-Decor.png",
        imageAlt: "Generating Home Decor Inspirations",
        imageLink: "https://youtu.be/vVuJdPIviw4",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/03/Patterns.png",
        imageAlt: "Generating Fabric Patterns",
        imageLink: "https://youtu.be/IzitYPp4XAw",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/03/Accessory.png",
        imageAlt: "Generating Accessory Inspirations",
        imageLink: "https://youtu.be/RZdK5OQeODs",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/03/Descriptions.png",
        imageAlt: "Generating Product Descriptions with AI",
        imageLink: "https://youtu.be/sjtIO3AuqH4",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/03/Retouch.png",
        imageAlt: "How to Edit Images with AI Retouch",
        imageLink: "https://youtu.be/OulfLFTGkDE",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/03/Sketch.png",
        imageAlt: "Convert Sketches into Realistic Images with AI",
        imageLink: "https://youtu.be/3c2IWJGMi5w",
    },
];